// extracted by mini-css-extract-plugin
export default {"passwordRequirements":"ChangePasswordModal_passwordRequirements__g0vNe"};